export const cleanDisplayValue = (value) => {
  if (value === null || value === undefined) return "";
  const text = String(value).replace(/\s+/g, " ").trim();
  const lowered = text.toLowerCase();
  return text && lowered !== "null" && lowered !== "undefined" ? text : "";
};

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const stripEmployeeIdFromName = (value, employeeId) => {
  const text = cleanDisplayValue(value)
    .replace(/^(applied|requested|approved|rejected|cancelled|canceled)\s*by\s*/i, "")
    .trim();
  const id = cleanDisplayValue(employeeId);
  if (!text) return text;

  if (!id) {
    return text.replace(/\s*\(?[A-Z]*\d{2,}\)?$/i, "").trim() || text;
  }

  // The ID is only cut when it is a separate trailing part ("Manoj - Manoj007",
  // "Manoj (Manoj007)"), matched case-sensitively. A name that merely ends with
  // the ID's letters, or is the ID itself ("Nelson" with ID "nelson"), is kept;
  // the old optional-separator, case-insensitive match emptied it to "N/A".
  const stripped = text
    .replace(
      new RegExp(`(?:\\s*[-\\u2013\\u2014|/]\\s*|\\s+)\\(?${escapeRegExp(id)}\\)?$`),
      "",
    )
    .trim();
  return stripped || text;
};

export const pickFirstValue = (row, fields) => {
  for (const field of fields) {
    const value = cleanDisplayValue(row?.[field]);
    if (value) return value;
  }
  return "";
};

export const pickFirstCleanName = (row, fields, employeeId) => {
  const id = employeeId || row?.employee_id || row?.emp_id || row?.employee_code;
  for (const field of fields) {
    const name = stripEmployeeIdFromName(row?.[field], id);
    if (name) return name;
  }
  return "";
};

export const normalizeApprovalPersonFields = (row) => {
  const employeeId = cleanDisplayValue(row?.employee_id || row?.emp_id || row?.employee_code);
  const employeeName =
    stripEmployeeIdFromName(
      row?.employee_name || row?.user_name || row?.username || row?.requested_by,
      employeeId,
    ) || "N/A";
  const appliedBy =
    pickFirstCleanName(
      row,
      ["applied_by_name", "requested_by_name", "applied_by", "requested_by"],
      employeeId,
    ) || employeeName;
  const approvedBy = pickFirstCleanName(
    row,
    ["approved_by_name", "approver_name", "approved_by"],
    employeeId,
  );
  const rejectedBy = pickFirstCleanName(row, ["rejected_by_name", "rejected_by"], employeeId);
  const cancelledBy = pickFirstCleanName(
    row,
    [
      "cancelled_by_name",
      "canceled_by_name",
      "cancelled_user_name",
      "canceled_user_name",
      "cancelled_by",
      "canceled_by",
    ],
    employeeId,
  );

  return {
    ...row,
    employee_name: employeeName,
    employee_id: employeeId || row?.employee_id || row?.emp_id || "-",
    applied_by: appliedBy,
    applied_on: pickFirstValue(row, [
      "applied_on",
      "applied_date",
      "created_at",
      "created_date",
      "requested_on",
    ]),
    approved_by: approvedBy,
    rejected_by: rejectedBy,
    cancelled_by: cancelledBy,
    approver_name: approvedBy || rejectedBy || cancelledBy || "-",
  };
};
